"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _container;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  container: (_container = {
    borderRadius: 4,
    borderWidth: 1,
    height: 32,
    transitionProperty: 'border',
    transitionDuration: '150ms',
    transitionTimingFunction: 'ease-in-out'
  }, _defineProperty(_container, "height", 40), _defineProperty(_container, "display", 'flex'), _defineProperty(_container, "flexDirection", 'row'), _container),
  input: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    flexGrow: 1,
    flexShrink: 1,
    outline: 'none',
    padding: 10,
    resize: 'none',
    fontFamily: 'Helvetica Neue',
    width: '100%'
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/TextInput/styles.js
// module id = ./node_modules/quark-web/components/form/TextInput/styles.js
// module chunks = 0